<template>
  <div>
    <div v-if="answerList.length > 0">
      <h3>Unmarked Answers: 
        <el-tag effect="dark">{{unmarkedAnswers.length}}</el-tag>
      </h3>
      <AnswerCollapseList :answerList="unmarkedAnswers"/>
      <h3>Marked Answers:
        <el-tag effect="dark">{{markedAnswers.length}}</el-tag>
      </h3>
      <AnswerCollapseList :answerList="markedAnswers"/>
      
    </div>
    <div v-else class="field-no-data">No answer submitted.</div>
  </div>
</template>

<script>
import { getAnswerListByHomework } from "@/api";
import AnswerCollapseList from "@/components/AnswerCollapseList.vue";

export default {
  name: "HomeworkAnswerList",
  components: {
    AnswerCollapseList
  },
  computed: {
    markedAnswers: function() {
      return this.answerList.filter(answer => answer.score !== null);
    },
    unmarkedAnswers: function() {
      return this.answerList.filter(answer => answer.score === null);
    }
  },
  data() {
    return {
      activeName: "",
      answerList: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const data = await getAnswerListByHomework(this.$route.params.homework_id);
      this.answerList = data;
    }
  }
};
</script>

<style scoped>
.field-no-data {
  text-align: center;
  padding: 16px 8px;
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.35);
}
</style>